"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PLTooltip;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _button = _interopRequireDefault(require("@ux/button"));
var _tooltip = _interopRequireDefault(require("@ux/tooltip"));
var _dialog = _interopRequireDefault(require("@ux/dialog"));
var _icon = require("@site/pattern-library-utils/icon");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const IconWrapper = /*#__PURE__*/(0, _react2.styled)(_button.default)({
  name: "IconWrapper",
  class: "core-i1gh8ien"
});
const TooltipWrapper = /*#__PURE__*/(0, _react2.styled)(_tooltip.default)({
  name: "TooltipWrapper",
  class: "core-t1vdbcdc"
});

/**
 * Tooltip Component
 *
 * @param {object} props React props
 * @param {string} props.title Tooltip title
 * @param {node} props.message Tooltip content
 * @param {string} props.ariaLabelTooltipClick Tooltip open icon aria label
 * @param {string} props.ariaLabelClose Tooltip close icon aria label
 * @returns {React.ReactElement} Tooltip Component
 * @public
 */

function PLTooltip({
  id,
  title,
  message,
  ariaLabelTooltipClick = 'open-tooltip',
  ariaLabelClose = 'close-tooltip',
  ...tooltipProps
}) {
  const [show, setShow] = (0, _react.useState)(false);
  const anchorRef = (0, _react.useRef)(null);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(IconWrapper, {
    id: `id-${id}`,
    ref: anchorRef,
    design: "inline",
    size: "small",
    onClick: () => setShow(!show),
    icon: /*#__PURE__*/_react.default.createElement(_icon.Icon, {
      name: "help"
    }),
    "aria-label": ariaLabelTooltipClick,
    "aria-haspopup": show,
    "data-cy": "tooltip-icon"
  }), /*#__PURE__*/_react.default.createElement(TooltipWrapper, (0, _extends2.default)({
    "data-cy": "tooltip",
    anchorRef: anchorRef,
    open: show,
    onClose: () => setShow(false)
  }, tooltipProps), /*#__PURE__*/_react.default.createElement(_dialog.default, {
    title: title,
    onClose: () => setShow(false),
    ariaLabels: {
      close: ariaLabelClose
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      maxWidth: '24ch'
    },
    "data-partial": 'dark1'
  }, message))));
}
PLTooltip.propTypes = {
  id: _propTypes.default.string,
  title: _propTypes.default.string,
  message: _propTypes.default.node,
  ariaLabelTooltipClick: _propTypes.default.string,
  ariaLabelClose: _propTypes.default.string,
  strategy: _propTypes.default.oneOf(['absolute', 'fixed']),
  placement: _propTypes.default.oneOf(['top', 'right', 'bottom', 'left', 'top-start', 'top-end', 'right-start', 'right-end', 'bottom-start', 'bottom-end', 'left-start', 'left-end']),
  ..._tooltip.default.propTypes
};